import { Grid } from "@material-ui/core";

import useProdutosBodyController from "../../controllers/ProdutosBodyController";
import SwitchesContainer from "../../commons/SwitchesContainer";
import { TabHeader } from "../../commons/TabHeader";

const TabGuias = () => {
  const { switchesGuides } = useProdutosBodyController();

  return (
    <>
      <TabHeader
        title="Visualização das guias no Cadastro de Produtos"
        subtitle="Defina quais guias serão exibidas no cadastro de produtos."
      />
      <Grid container direction="column">
        {switchesGuides.map(({ ...props }, i) => (
          <SwitchesContainer key={i} {...props} />
        ))}
      </Grid>
    </>
  );
};

export default TabGuias;
